import { render, staticRenderFns } from "./meal-form.vue?vue&type=template&id=4c8640d9&"
import script from "./meal-form.vue?vue&type=script&lang=js&"
export * from "./meal-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports